import { FlexLayout, H4 } from '@deity/falcon-ui';
import { Select } from '@deity-io/portal-ui';
import type { FC } from 'react';

interface ConnectionProps {
  isEditable: boolean;
  service?: string;
  type?: string;
  onChange?: (key: string[], val: string) => void;
}
const Connection: FC<ConnectionProps> = ({ isEditable, type, onChange, service }) => (
  <FlexLayout p="xxl" flexDirection="column">
    <H4 fontWeight="semiBold" fontSize="xl">
      {service}
    </H4>
    <Select
      label="Connection Type"
      sx={{ marginY: 1 }}
      onChange={(val: any) => (onChange ? onChange(['type'], val?.value) : undefined)}
      options={[{ label: type?.toUpperCase() || '', value: type || '' }]}
      value={{ label: type?.toUpperCase() || '', value: type || '' }}
      disabled={!isEditable}
      disableClearable
    />
  </FlexLayout>
);

export default Connection;
